<template>
  <div class="hotel_container">
    <el-row>
      <Loading :loading="submitLoading" />
      <el-col :span="24">
        <div v-if="$objBaseInfo.channelId === 'WEB'" class="grid-content content_size" style="margin-top: 1rem">
          <el-breadcrumb separator-class="el-icon-arrow-right" style="height: 5rem; line-height: 5rem">
            <el-breadcrumb-item>{{
              $t("RESULT.SEARCHHOTEL")
            }}</el-breadcrumb-item>
            <el-breadcrumb-item>{{
              $t("GUARANTEE.SELECTHOTEL")
            }}</el-breadcrumb-item>
            <el-breadcrumb-item>{{
              $t("DETAIL.DETAILPAGE")
            }}</el-breadcrumb-item>
            <el-breadcrumb-item>{{ $t("BOOKING.BOOKING") }}</el-breadcrumb-item>
            <el-breadcrumb-item>{{
              $t("GUARANTEE.GUARANTEE")
            }}</el-breadcrumb-item>
          </el-breadcrumb>
        </div>
        <div class="warning_sty content_size align_center">
          <span class="fontstyle" style="margin-left: 1rem">
            {{ $t("GUARANTEE.REMINDER") }}
          </span>
        </div>
        <div id="nav2">
          <div id="box4">
            <!-- {{ $t("RESULT.HOTEL1") }} -->
            <span class="big_font">{{ showHotelName(orderInfo.hotelName) }}</span>
            <el-row :gutter="10" style="
                margin: 1.3rem 1.3rem 0;
                border-bottom: 0.2rem dotted #979797;
              ">
              <el-col :xs="24" :sm="24" :md="5" style="padding-left: 0">
                <div class="grid-content bg-purple">
                  <span class="grey_small_font">{{ $t("GUARANTEE.CHECKINDATE") }}
                    <span class="small_font">{{ orderInfo.checkInAt }}</span>
                  </span>
                </div>
              </el-col>
              <el-col :xs="24" :sm="24" :md="5" style="padding-left: 0">
                <div class="grid-content bg-purple">
                  <span class="grey_small_font">{{ $t("GUARANTEE.CHECKOUTDATE") }}
                    <span class="small_font">{{ orderInfo.checkOutAt }}</span>
                  </span>
                </div>
              </el-col>
              <el-col :xs="24" :sm="24" :md="5" style="padding-left: 0">
                <div class="grid-content bg-purple">
                  <span class="grey_small_font">
                    {{ $t('GUARANTEE.ROOMNUMBER_PREFIX') }}
                    <span class="small_font">{{ orderInfo.nights }}</span>
                    {{ $t('GUARANTEE.ROOMNUMBER_SUFFIX') }}
                  </span>
                </div>
              </el-col>
              <el-col :xs="24" :sm="24" :md="5" style="padding-left: 0">
                <div class="grid-content bg-purple">
                  <span class="grey_small_font">
                    {{ $t('GUARANTEE.NIGHTS_PREFIX') }}
                    <span class="small_font">{{ orderInfo.roomCount }}</span>
                    {{ $t('GUARANTEE.NIGHTS_SUFFIX') }}
                  </span>
                </div>
              </el-col>
              <el-col :xs="24" :sm="24" :md="4" style="padding-left: 0">
                <div class="grid-content bg-purple">
                  <span class="grey_small_font">{{ $t("GUARANTEE.TOTALAMOUNT") }}
                    <span class="small_font">{{ this.$objBaseInfo.defaultCurrencySign + orderInfo.totalPrice }}</span>
                  </span>
                </div>
              </el-col>
            </el-row>
          </div>
          <!-- 房间信息 -->
          <div id="box5">
            <div class="grey_small_font" style="margin-left: 1.3rem; padding-top: 1.3rem; display: flex">
              <span class="label_name_text">
                {{ $t("GUARANTEE.ROOMTYPE") }}
              </span>
              <span class="small_font mobile_span_room">{{
                orderInfo.roomName[$t("COMMONPARAM.RESPONSEDATA.SHOWTYPE")]
              }}</span>
            </div>
            <div class="grey_small_font" style="margin-left: 1.3rem; padding-top: 1.3rem; display: flex">
              <span class="label_name_text">
                {{ $t("BOOKING.DESCRIPTION") }}
              </span>
              <span class="mobile_span_room">
                <span class="small_font">{{ roomTypeInfo }}</span>
              </span>
            </div>
            <div class="grey_small_font item" style="
                margin-left: 1.3rem;
                margin-right: 1.3rem;
                padding-top: 1.3rem;
                display: flex;
              ">
              <span class="label_name_text">
                {{ $t("GUARANTEE.BREAKFAST1") }}
              </span>
              <!-- 早餐 -->
              <span class="small_font mobile_span_room" v-if="orderInfo.breakfastQty == 0 && bookParam.breakfastFlag">
                {{ $t("BOOKING.NOBREAKFAST") }}
              </span>
              <span class="small_font"
                v-if="orderInfo.breakfastQty > 0 && orderInfo.breakfastQty < 99 && bookParam.breakfastFlag">
                {{
                  $t("BOOKING.BREAKFASTNUM", {
                    num: orderInfo.breakfastQty,
                  })
                }}
              </span>
              <span class="small_font" v-if="orderInfo.breakfastQty == 99 && bookParam.breakfastFlag">
                {{ $t("BOOKING.BREAKFAST99") }}
              </span>
              <span class="small_font" v-if="!bookParam.breakfastFlag && bookParam.sabreBreakfast">
                {{ $t("BOOKING.BREAKFAST99") }}
              </span>
              <span class="small_font" v-if="!bookParam.breakfastFlag && !bookParam.sabreBreakfast">
                {{ $t("BOOKING.NOBREAKFAST") }}
              </span>
            </div>
          </div>
          <!-- 入住人信息 -->
          <div id="box6">
            <!-- 入住人姓名 -->
            <div class="grey_small_font" style="margin-left: 1.3rem; padding-top: 1.3rem; display: flex">
              <span class="label_name_text">
                {{ $t("GUARANTEE.NAME") }}
              </span>
              <span class="small_font mobile_span_room">{{ roomGuests.name }}</span>
            </div>
            <!-- 电话 -->
            <div class="grey_small_font" style="margin-left: 1.3rem; padding-top: 1.3rem; display: flex">
              <span class="label_name_text">
                {{ $t("GUARANTEE.TEL") }}
              </span>
              <span class="small_font mobile_span_room">{{ roomGuests.contact.mobile }}</span>
            </div>
            <!-- 邮箱 -->
            <div class="grey_small_font item" style="margin-left: 1.3rem; padding-top: 1.3rem; display: flex">
              <span class="label_name_text">
                {{ $t("GUARANTEE.EMAIL") }}
              </span>
              <span class="small_font mobile_span_room">{{ roomGuests.contact.email }}</span>
            </div>
          </div>

          <div id="box6" style="padding-bottom: 1.3rem">
            <div class="grey_small_font" style="margin-left: 1.3rem; padding-top: 1.3rem">
              <span>{{ $t("GUARANTEE.SUPPORTCREDITCARD") }}</span>

              <div><svg-icon v-for="item in cardTypes" :key="item.creditCardCompanyCode" :icon-class="item.iconUrl"
                  style="margin-left: 2rem; margin-bottom: -0.5rem"></svg-icon></div>
            </div>
          </div>
        </div>
        <div id="nav">
          <div id="box1">
            <span class="small_font" style="margin-left: 1.3rem">{{
              $t("CONFIRMATION.GUARANTEEINFO")
            }}</span>
          </div>

          <div id="box2">
            <el-form ref="cardForm" :model="creditCardForm"
              :label-position="$objBaseInfo.channelId === 'WEB' ? 'left' : 'top'">
              <el-row>
                <!-- 信用卡类型 -->
                <el-col :xs="24" :sm="10">
                  <div class="grid-content bg-purple-light">
                    <el-form-item :label="$t('GUARANTEE.CREDITCARDTYPE')" label-width="15rem" prop="cardType" :rules="{
                      required: true,
                      message: this.$t('GUARANTEE.RULECREDITTYPE'),
                      trigger: ['blur', 'change'],
                    }">
                      <el-select v-model="creditCardForm.cardType" class="holewidth" :disabled="addcardvaluef"
                        @change="changeCardType">
                        <el-option v-for="item in cardTypes" :key="item.creditCardCompanyCode" :label="item.creditCardNameList[
                          $t('COMMONPARAM.RESPONSEDATA.SHOWTYPE')
                        ]
                          " :value="item.creditCardCompanyCode">
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </div>
                </el-col>
                <!-- 信用卡号 -->
                <el-col :xs="24" :sm="10">
                  <div class="grid-content bg-purple-light">
                    <el-form-item :label="$t('GUARANTEE.CARDNUMBER')" label-width="17rem" prop="creditcard" :rules="[
                      {
                        required: true,
                        message: this.$t('GUARANTEE.RULECREDITCARD'),
                        trigger: 'blur',
                      },
                      {
                        validator: regxCard,
                        trigger: 'blur',
                      },
                    ]">
                      <el-input v-show="addcardvalue"
                        v-model="creditCardForm.creditcard"
                        type="password"
                        show-password
                        :placeholder="$t('MESSAGE.PLEASEINPUT')"
                      />
                      <el-select v-model="creditCardForm.creditcard" class="holewidth" v-show="!addcardvalue"
                        @change="changeCard" :no-data-text="$t('GUARANTEE.CARDNULLMSG')">
                        <el-option v-for="item in creadcard" :key="item.creditCardNo"
                          :label="replaceStar(item.creditCardNo, item.isVirtualCard)" :value="item.creditCardNo">
                        </el-option>
                      </el-select>
                      <span v-show="creditCardForm.isVirtualCard" style="color:red;">本单为虚拟卡担保</span>
                    </el-form-item>
                  </div>
                </el-col>
                <!-- 持卡人姓名 -->
                <el-col :xs="24" :sm="10">
                  <div class="grid-content bg-purple-light">
                    <el-form-item :label="$t('GUARANTEE.NAMEOFCARDHOLDER')" label-width="15rem" prop="cardNumberName"
                      :rules="[
                        {
                          required: true,
                          message: this.$t('GUARANTEE.RULECARDNAME'),
                          trigger: 'blur',
                        },
                        {
                          validator: cardNameRule,
                          trigger: 'blur',
                        },
                      ]">
                      <el-input :placeholder="$t('GUARANTEE.INPUTCARDHOLDER')"
                        v-model="creditCardForm.cardNumberName">
                      </el-input>
                    </el-form-item>
                  </div>
                </el-col>
                <!-- 有效期 -->
                <el-col :xs="24" :sm="10">
                  <div class="grid-content bg-purple-light">
                    <el-form-item :label="$t('GUARANTEE.PERIODOFVALIDITY')" label-position="left" label-width="17rem"
                      prop="validityDate" :rules="[
                        {
                          required: true,
                          message: this.$t('GUARANTEE.RULEVALIDITYDATE'),
                          trigger: 'blur',
                        },
                        {
                          validator: cardValidityDate,
                          trigger: ['blur', 'change'],
                        },
                      ]">
                      <el-date-picker 
                        class="grey_input" 
                        format="MM/YYYY"
                        :disabled="addcardvaluef"
                        v-model="creditCardForm.validityDate" 
                        type="month"
                        :placeholder="$t('MESSAGE.PLEASEINPUT')" 
                        :disabled-date="disabledDate"
                        ref="datePicker" 
                        @focus="dateFocus"
                      />
                    </el-form-item>
                  </div>
                </el-col>
                <!-- CVV -->
                <el-col v-if="this.bookParam.isNeedCvv" :xs="24" :sm="10">
                  <div class="grid-content bg-purple-light">
                    <el-form-item label="CVV" label-width="15rem" prop="CVV" :rules="[
                      {
                        required: true,
                        message: this.$t('GUARANTEE.RULECHINESECVV'),
                        trigger: 'blur',
                      },
                      // {
                      //   pattern: /^\d{3}$/,
                      //   message: this.$t('GUARANTEE.RULECHINESECVV'),
                      //   trigger: ['blur', 'change'],
                      // },
                      {
                        validator: cvvValidity,
                        trigger: ['blur', 'change'],
                      },
                    ]">
                      <el-input class="grey_input" :placeholder="$t('GUARANTEE.RULECHINESECVV')"
                        v-model="creditCardForm.CVV">
                      </el-input>
                    </el-form-item>
                  </div>
                </el-col>
                <!-- 是否保存 -->
                <el-col v-if="!addcardbtn" :xs="24" :sm="24">
                  <div class="grid-content save-check">
                    <el-checkbox v-model="isCardSaved">{{ $t("GUARANTEE.SAVECARDINFOMATION") }}</el-checkbox>
                  </div>
                </el-col>
                <!-- 证件类型 -->
                <el-col v-if="isCardSaved" :xs="24" :sm="10">
                  <div class="grid-content bg-purple-light">
                    <el-form-item :label="$t('GUARANTEE.IDTYPE')" label-width="15rem" prop="idCardType" :rules="[
                      {
                        required: true,
                        message: this.$t('GUARANTEE.RULECARDNUM'),
                        trigger: 'blur',
                      },
                    ]">
                      <el-select v-model="creditCardForm.idCardType" class="holewidth">
                        <el-option v-for="item in idTypes" :key="item.code"
                          :label="item.label[$t('COMMONPARAM.RESPONSEDATA.SHOWTYPE')]" :value="item.code">
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </div>
                </el-col>
                <!-- 证件号 -->
                <el-col v-if="isCardSaved" :xs="24" :sm="10">
                  <div class="grid-content bg-purple-light">
                    <el-form-item :label="$t('GUARANTEE.IDNUMBER')" label-width="15rem" prop="idCardNum" :rules="[
                      {
                        required: true,
                        message: this.$t('GUARANTEE.RULECARDNUM'),
                        trigger: 'blur',
                      },
                      {
                        validator: idCardRule,
                        trigger: 'blur',
                      },
                    ]">
                      <el-input class="grey_input" v-model="creditCardForm.idCardNum">
                      </el-input>
                    </el-form-item>
                  </div>
                </el-col>
                <!-- 发卡银行 -->
                <el-col v-if="isCardSaved" :xs="24" :sm="10">
                  <div class="grid-content bg-purple-light">
                    <el-form-item :label="$t('GUARANTEE.ISSUEBANK')" label-width="15rem" prop="bankName" :rules="[
                      {
                        required: true,
                        message: this.$t('GUARANTEE.RULECARDNUM'),
                        trigger: 'blur',
                      },
                    ]">
                      <el-select v-model="creditCardForm.bankName" class="holewidth">
                        <el-option v-for="item in issuebankvalue" :key="item.code"
                          :label="item.label[$t('COMMONPARAM.RESPONSEDATA.SHOWTYPE')]" :value="item.code">
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </div>
                </el-col>
                <!-- 注册手机号 -->
                <el-col v-if="isCardSaved" :xs="24" :sm="10">
                  <div class="grid-content bg-purple-light">
                    <el-form-item :label="$t('GUARANTEE.MOBILEPHONE')" label-width="15rem" prop="mobilePhone" :rules="[
                      {
                        required: true,
                        message: this.$t('BOOKING.VALIDATEMES2'),
                        trigger: ['blur', 'change'],
                      },
                      {
                        pattern: /^1[3456789]\d{9}$/,
                        message: this.$t('BOOKING.PHONEVA'),
                        trigger: ['blur', 'change'],
                      },
                    ]">
                      <el-input :required="true" v-model="creditCardForm.mobilePhone" autocomplete="off"></el-input>
                    </el-form-item>
                  </div>
                </el-col>
                <!-- 卡性质 -->
                <el-col v-if="isCardSaved" :xs="24" :sm="10">
                  <div class="grid-content bg-purple-light">
                    <el-form-item :label="$t('GUARANTEE.CARDPROPERTY')" label-width="15rem" prop="property"
                      :required="true">
                      <el-radio-group v-model="creditCardForm.property">
                        <el-radio label="Company">{{
                          $t("GUARANTEE.CARDPROPERTYCOM")
                        }}</el-radio>
                        <el-radio label="Personal" style="margin-left: 2rem">{{
                          $t("GUARANTEE.CARDPROPERTYPER")
                        }}</el-radio>
                      </el-radio-group>
                    </el-form-item>
                  </div>
                </el-col>
                <!-- 是否默认 -->
                <el-col v-if="isCardSaved" :xs="24" :sm="10">
                  <div class="grid-content bg-purple-light">
                    <el-form-item prop="isFirst">
                      <el-checkbox v-model="creditCardForm.isFirst">{{ $t("GUARANTEE.ISFIRST") }}</el-checkbox>
                    </el-form-item>
                  </div>
                </el-col>
              </el-row>
            </el-form>
          </div>
          <!-- 提交按钮 -->
          <div id="box3" style="padding-bottom: 1.3rem">
            <el-row>
              <button @click="addcard()" v-show="addcardbtn" class="s_btn s_btn_small" style="width: 17.6rem">
                <span>{{ $t("GUARANTEE.ADDNEWCARD") }}</span>
              </button>
              <button class="s_btn s_btn_small" v-bind:class="{ 'is-disabled': !isChecked }" style="width: 17.6rem"
                @click="toConfirmation">
                <span>{{ $t("GUARANTEE.CONFIRMBOOKING") }}</span>
              </button>
              <button @click="backBooking()" v-show="isShowBack" class="s_btn s_btn_small" style="width: 17.6rem">
                <span>{{ $t("CONFIRMATION.BACK") }}</span>
              </button>
            </el-row>
          </div>
        </div>
      </el-col>

      <ConfirmBoxs :centerDialogVisible="confirmFlag" :confirmMsg="confirmMsg" :icon="confirmIcon"
        @setConfirmFlag="setConfirmFlag"></ConfirmBoxs>
    </el-row>
  </div>
</template>

<script>
import { createBooking } from "../../api/bookingData.js";
import { geCreditCard, getCreditCardLookup, getCreditCardAdd, getuserinfo, searchPosHotelVirtualCard } from "../../api/platformData.js";
import ConfirmBoxs from "../../components/confirmBoxs.vue";
import Loading from "@/components/Loading.vue";
import {
  hideElement,
  getCreditType,
  isEnglish,
  codeIsCode,
  getCardType,
  issuerBank,
} from "@/utils/utils.js";
export default {
  name: "Guarantee",
  components: {
    ConfirmBoxs,
    Loading,
  },
  data() {
    //持卡人姓名正则 英文
    var validatePass = (rule, value, callback) => {
      //英文 必须是全英加空格
      var regchina = new RegExp("^[\u4E00-\u9FA5]+$");
      if (!regchina.test(value) && !isEnglish(value)) {
        callback(new Error(this.$t("GUARANTEE.CARDNAMEVALIDATE")));
      } else {
        callback();
      }
    };
    //信用卡拦截
    var validatePassCard = (rule, value, callback) => {
      var CreditCard = require("credit-card");
      if (
        CreditCard.isValidCardNumber(
          value,
          getCreditType(this.creditCardForm.cardType)
        ) &&
        value != "4111111111111111"
      ) {
        callback();
      } else {
        callback(new Error(this.$t("GUARANTEE.RULECREDITVIL")));
      }
    };
    //有效期拦截
    var cardValidityDate = (rule, value, callback) => {
      //callback();
      let monthStartDate = new Date(new Date().getFullYear(), new Date().getMonth(), 1);
      if (new Date(value) >= monthStartDate) {
        callback();
      } else {
        callback(new Error(this.$t("GUARANTEE.RULEVALIDITYDATE3")));
      }
    };
    //CVV验证
    var cvvValidity = (rule, value, callback) => {
      //默认三位CVV数字
      let regExp = /^\d{3}$/;
      //美国运通卡需要四位的CVV
      if (this.creditCardForm.cardType == "AX") {
        regExp = /^\d{4}$/;
      }
      if (!regExp.test(value)) {
        callback(new Error(this.$t("GUARANTEE.RULECHINESECVV")));
      } else {
        callback();
      }
      callback();
    };
    var validatePassIdCard = (rule, value, callback) => {
      let card = this.idTypes.find((idType) => {
        if (idType.code == this.creditCardForm.idCardType) {
          return idType;
        } else {
          return null;
        }
      });
      if (card) {
        if (!card.pattern || card.pattern.test(value)) {
          callback();
        } else {
          callback(new Error(this.$t("GUARANTEE.RULEIDTYPE")));
        }
      } else {
        callback();
      }
    };
    return {
      isChecked: true,
      confirmFlag: false,
      confirmMsg: "",
      confirmIcon: "",
      submitLoading: false,
      creditCardForm: {
        validityDate: "",
        cardNumberName: "",
        creditcard: "",
        cardType: "",
        CVV: "",
        isVirtualCard: false,//是否虚拟卡
      },
      cardholder: "",
      mobileinput: "",
      idNumber: "",
      checked: "",
      idTypes: getCardType(),
      cardTypes: [],
      cardNameRule: validatePass,
      idCardRule: validatePassIdCard,
      creadcard: [],
      issuebankvalue: issuerBank(),
      idtypevalue: [],
      cardtypevalue: [],
      addcardvalue: false,
      addcardvaluef: true,
      addcardbtn: true,
      cardValue: "0",
      orderInfo: { hotelName: {}, roomName: {} },
      bookParam: {}, //创建订单需要的信息
      orderParam: {},
      regxCard: validatePassCard,
      roomGuests: { contact: { mobile: "" } }, //入住人信息
      bookingAgents: {},//预定人信息
      cardValidityDate: cardValidityDate,
      cvvValidity: cvvValidity,
      orderIdTo: "", //订单ID
      isCardSaved: false,
      roomTypeInfo: "",
      cardCompany: [], //支持的信用卡类型
      NOSabreCardCompany: ["UP"],//不支持的信用卡类型-Sabre
      AgentsUserInfo: {}, //userinfo
      isShowBack: false,
      VirtualCard: null,//虚拟卡
    };
  },
  created() {
    if (this.$objBaseInfo.channelId === "MOBILE") {
      this.$nextTick(() => {
        //不显示回退按钮
        let goHistray = document.querySelector(".van-nav-bar__left");
        goHistray.setAttribute("style", "display:none");
      });
    }
  },
  watch: {
    "$i18n.locale"() {
      this.getRoomTypeInfo();
      this.$refs["cardForm"].clearValidate();
    },
  },
  async mounted() {
    //判断来源 CRM跳转过来隐藏部分元素
    hideElement(this);
    //
    let createGuarantee = window.sessionStorage.getItem("createGuarantee");
    if (!createGuarantee) {
      return false;
    }
    //移除面包屑的样式
    let classList = document.querySelectorAll(".el-breadcrumb__inner");
    for (const iterator of classList) {
      iterator.removeAttribute("class");
    }
    this.submitLoading = true;
    this.orderInfo = JSON.parse(createGuarantee);
    await this.getRoomTypeInfo();
    this.bookParam = this.orderInfo.bookParam;
    console.log("bookParam", this.bookParam);
    this.roomGuests = this.bookParam.roomGuests[0];
    this.bookingAgents = this.bookParam.bookingAgents[0];
    this.isShowBack = this.orderInfo.isGuaranteeType;
    await this.getuserInfo();
    this.cardTypes = [];
    console.log(this.orderInfo.supportedCreditCards);
    // this.orderInfo.supportedCreditCards=[];
    if (this.$objBaseInfo.sourceType == "CRM" && this.bookParam.source.indexOf("sabre") >= 0) {
      await this.getVirtualCard();
    }
    //信用卡公司信息
    await geCreditCard({ params: { page: 1, par_page: 10 } })
      .then((res) => {
        this.submitLoading = false;
        if (res.code === 200) {
          if (res.data.error.code != 0) {
            this.confirmFlag = true;
            this.confirmMsg =
              this.$t("ERRORMESSAGE." + res.data.error.code) ===
                "ERRORMESSAGE." + res.data.error.code
                ? this.$t("ERRORMESSAGE.NOTFOUND")
                : this.$t("ERRORMESSAGE." + res.data.error.code);
            console.log(
              "信用卡公司信息获取失败, code:" + res.data.error.code,
              res.data.error.message
            );
          } else {
            if (this.orderInfo.supportedCreditCards.length == 0) {
              let list = res.data.list;
              if (list.length > 0) {
                //排除sabre不支持银行卡类型
                if (this.bookParam.source.indexOf("sabre") >= 0) {
                  list = list.filter(p => this.NOSabreCardCompany.indexOf(p.creditCardCompanyCode) < 0);
                }
              }
              this.cardTypes = list;
              for (const item of this.cardTypes) {
                //排除sabre不支持银行卡类型
                if (!(this.bookParam.source.indexOf("sabre") >= 0 && this.NOSabreCardCompany.indexOf(item.creditCardCompanyCode) >= 0)) {
                  this.cardCompany.push(item.creditCardCompanyCode);
                }
              }
              this.getCreditCardList();
            } else if (
              res.data.list.length > 0 &&
              this.orderInfo.supportedCreditCards.length > 0
            ) {
              const virtualCardCode = this.VirtualCard?.CreditCardCompanyCode;
              const validVirtualCode = virtualCardCode !== undefined && virtualCardCode !== null
                ? String(virtualCardCode)
                : '';
              for (const item of res.data.list) {
                const itemCode = item.creditCardCompanyCode;
                const validItemCode = itemCode !== undefined && itemCode !== null
                  ? String(itemCode)
                  : '';

                if (
                  this.orderInfo.supportedCreditCards.indexOf(itemCode) > -1 ||
                  (validVirtualCode && validItemCode.includes(validVirtualCode))
                ) {
                  this.cardTypes.push(item);
                }
              }
              this.cardCompany = this.orderInfo.supportedCreditCards;
              this.getCreditCardList();
            }
          }
        } else {
          this.confirmFlag = true;
          this.confirmMsg = "信用卡公司信息获取失败" + res.message;
          console.log(
            "信用卡公司信息获取失败, code:" + res.data.error.code,
            res.data.error.message
          );
        }
      })
      .catch((err) => {
        this.submitLoading = false;
        this.confirmFlag = true;
        this.confirmMsg = this.$t("ERRORMESSAGE." + err.mesCode);
        console.log("信用卡公司信息获取失败", err.objError);
      });
  },
  methods: {
    showHotelName(hotelName) {
      if (this.$objBaseInfo.sourceType == "CRM") {
        if (this.$objBaseInfo.isGATCity || this.$objBaseInfo.destinationType == "I") {
          return hotelName["zh-CN"] + '(' + hotelName["en"] + ')';
        }
      }
      return hotelName[this.$t("COMMONPARAM.RESPONSEDATA.SHOWTYPE")];
    },
    async getVirtualCard(customerParam) {
      try {
        let customerParam = {
          params: {
            customerCode: this.bookParam.posCode,
          },
        };
        const res = await searchPosHotelVirtualCard(customerParam);
        if (res.code === 200) {
          const { items } = res.data || {};
          if (items && items.length > 0) {
            this.VirtualCard = items[0];
          }
        }
      } catch (error) {
        console.error('获取虚拟卡失败：', error);
      }
    },

    // 调用方式（注意：调用 async 函数本身会返回 Promise）
    // this.getVirtualCard(yourCustomerParam);
    dateFocus() {
      this.$nextTick(res => {
        this.$refs.datePicker.focus();
      });
    },
    disabledDate(time) {
      // 禁用今天之前的日期
      return time.getTime() < Date.now();
    },
    // 房型信息拼接
    getRoomTypeInfo() {
      let info_arr = [];
      if (this.orderInfo.floor && this.orderInfo.floor.trim() != "") {
        info_arr.push(
          this.$t("BOOKING.ROOMDESCRIPTION", {
            floor: this.orderInfo.floor,
          })
        );
      }
      if (this.orderInfo.area && this.orderInfo.area.trim() != "") {
        info_arr.push(
          this.$t("BOOKING.ROOMDESCRIPTIONAREA", {
            area: this.orderInfo.area,
          })
        );
      }
      if (this.orderInfo.wifi || this.orderInfo.wifi == 0) {
        this.$t("COMMONPARAM.WIFI.WIFI" + this.orderInfo.wifi) !=
          "COMMONPARAM.WIFI.WIFI" + this.orderInfo.wifi
          ? info_arr.push(
            this.$t("COMMONPARAM.WIFI.WIFI" + this.orderInfo.wifi)
          )
          : "";
      }
      if (this.orderInfo.window || this.orderInfo.window == 0) {
        this.$t("COMMONPARAM.WINDOW.WINDOW" + this.orderInfo.window) !=
          "COMMONPARAM.WINDOW.WINDOW" + this.orderInfo.window
          ? info_arr.push(
            this.$t("COMMONPARAM.WINDOW.WINDOW" + this.orderInfo.window)
          )
          : "";
      }
      this.roomTypeInfo = info_arr.join(", ");
    },
    //新增信用卡
    async addCreditCard() {
      let param = {
        userCode: this.$objBaseInfo.userCode,
        userID: this.AgentsUserInfo.pkid,
        creditCardType: this.creditCardForm.cardType,
        creditCardName: this.creditCardForm.cardNumberName,
        creditCardNo: this.creditCardForm.creditcard,
        creditCardDate: this.toAddValidate(this.creditCardForm.validityDate),
        bankCode: this.creditCardForm.bankName,
        mobilePhone: this.creditCardForm.mobilePhone,
        natureCode: this.creditCardForm.property,
        isFirst: this.creditCardForm.isFirst ? true : false,
        cardType: getCardType(this.creditCardForm.idCardType),
        cardID: this.creditCardForm.idCardNum,
        loginID: this.bookingAgents.userId,
      };
      await getCreditCardAdd(param)
        .then((res) => {
          console.log("新增信用卡保存", res);
        })
        .catch((error) => {
          console.log("新增信用卡保存异常", error.objError);
        });
    },
    replaceStar(value, isVirtualCard) {
      if (value && value.length > 8) {
        let reg = /^(\d{4})(\d*)(\d{4})$/;
        let str = value.replace(reg, (a, b, c, d) => {
          return b + c.replace(/\d/g, "*") + d;
        });
        let VirtualCardStr = "";
        if (isVirtualCard) {
          VirtualCardStr = "    虚拟卡需二次确认";
        }
        return str + VirtualCardStr;
      } else {
        return value;
      }
    },
    changeCardType() { },
    setConfirmFlag() {
      this.confirmFlag = false;
      if (this.orderIdTo != "") {
        this.toCon(this.orderIdTo);
      }
    },
    changeCard(value) {
      let oneCard = this.creadcard.find((item) => item.creditCardNo.trim() == value);
      if (this.cardCompany.indexOf(oneCard.creditCardType.trim()) > -1) {
        this.cardValue = value;
        this.creditCardForm.validityDate = this.toValidate(
          oneCard.creditCardDate
        );
        this.creditCardForm.cardNumberName = oneCard.creditCardName.trim();
        this.creditCardForm.creditcard = oneCard.creditCardNo.trim();
        this.creditCardForm.cardType = oneCard.creditCardType;
        this.creditCardForm.isVirtualCard = oneCard.isVirtualCard;
      } else {
        this.creditCardForm.validityDate = "";
        this.creditCardForm.cardNumberName = "";
        this.creditCardForm.cardType = "";
        this.confirmMsg = this.$t("GUARANTEE.CARDTYPETIPS");
        this.confirmFlag = true;
      }
    },
    addcard: function () {
      this.addcardvalue = true;
      this.addcardvaluef = false;
      this.addcardbtn = false;
      this.creditCardForm.cardNumberName = "";
      this.creditCardForm.creditcard = "";
      this.creditCardForm.validityDate = "";
      this.creditCardForm.cardType = "";
      this.creditCardForm.isVirtualCard=false;
      this.$refs["cardForm"].resetFields();
    },
    //获取入住人的信用卡
    async getCreditCardList() {
      this.creadcard = [];
      let params = {
        params: {
          travelerCode: this.bookingAgents.userId,
          page: 1,
          per_page: 20,
        },
      };
      let that = this;
      await getCreditCardLookup(params)
        .then((res) => {
          // 信用卡信息
          if (res.code === 200) {
            if (res.data.error.code != 0) {
              console.log(
                "信用卡信息获取异常,code:" + res.data.error.code,
                res.data.error.message
              );
            } else {
              for (const item of res.data.items) {
                if (that.cardCompany.indexOf(item.creditCardType) > -1) {
                  that.creadcard.push(item);
                }
              }
              if (
                that.creadcard != null &&
                that.creadcard != undefined &&
                that.creadcard.length > 0
              ) {
                let defaultCard = that.creadcard.find((item) => {
                  if (item.isFirst) {
                    return item;
                  }
                });
                if (!defaultCard) {
                  defaultCard = that.creadcard[0];
                }
                that.cardValue = defaultCard.creditCardNo;
                that.creditCardForm.validityDate = that.toValidate(
                  defaultCard.creditCardDate
                );
                that.creditCardForm.cardNumberName = defaultCard.creditCardName.trim();
                that.creditCardForm.creditcard = defaultCard.creditCardNo.trim();
                that.creditCardForm.cardType = defaultCard.creditCardType.trim();
              }
              if (that.VirtualCard != null && that.VirtualCard != undefined) {
                that.creadcard.push(that.VirtualCard);
              }
            }
          } else {
            console.log(
              "信用卡信息获取异常, code:" + res.data.error.code,
              res.data.error.message
            );
          }
        })
        .catch((err) => {
          console.log("信用卡信息获取异常", err.objError);
        });
    },
    //信用卡有效期转换
    toValidate(validate) {
      if (validate) {
        //当年年份前两个字符
        const yyF = new Date().getFullYear().toString().substr(0, 2);
        if (validate.toString().length == 4) {
          //时间格式 MMYY
          const yyyyF = yyF + validate.toString().substr(2, 2);
          const mmF = validate.toString().substr(0, 2);
          return yyyyF + "-" + mmF + "-" + "01";
        } else if (
          validate.toString().length == 5 &&
          validate.toString().indexOf("/") > -1
        ) {
          //时间格式 MM/YY
          const dateArr = validate.split("/");
          return yyF + dateArr[1] + "-" + dateArr[0] + "-" + "01";
        } else if (
          //时间格式 yyyy-MM-ddThh:mm:ss.000Z
          validate.toString().indexOf("T") > -1
        ) {
          let shortDate = validate.toString().substr(0, 10);
          return shortDate;
        } else {
          console.log("信用卡有效期：", validate);
        }
      } else {
        console.log("信用卡有效期：", validate);
        return validate;
      }
    },
    toAddValidate(validate) {
      let tf = function (i) {
        return (i < 10 ? "0" : "") + i;
      };
      let date = new Date(validate);
      return (
        tf(date.getMonth() + 1) +
        date.getFullYear().toString().substring(2, 4)
      );
    },
    toCon(orderId) {
      if(orderId!=null && orderId!=undefined && orderId!="")
      {
        sessionStorage.removeItem("createOrder");
        sessionStorage.removeItem("createGuarantee");
        sessionStorage.removeItem(this.$objBaseInfo.sourceType + "LastOrderNo");
        sessionStorage.removeItem("OBTItineraryOrder");
        this.$router.push({
          name: "Confirmation",
          query: { orderId: orderId, sourceType: this.$objBaseInfo.sourceType },
        });
       }
    },
    toConfirmation: function () {

      this.submitLoading = true;
      this.isChecked = false;
      this.$refs["cardForm"].validate((valid) => {
        if (valid) {
          if (this.isCardSaved) {
            //将信用卡信息保存
            this.addCreditCard();
          }
          //调用创建订单的接口
          this.bookParam.isCPHotel =
            this.bookParam.isCPHotel.toString() == "true" ? true : false;
          this.bookParam.isAPHotel =
            this.bookParam.isAPHotel.toString() == "true" ? true : false;
          let isOutOfPolicy = null;
          if (this.bookParam.isOutOfPolicy != undefined) {
            isOutOfPolicy = this.bookParam.isOutOfPolicy.toString() == "true" ? true : false;
          }
          this.bookParam.isOutOfPolicy = isOutOfPolicy;
          this.bookParam.isManualOrder = false;
          this.bookParam.roomGuests[0].isEmployee =
            this.bookParam.roomGuests[0].isEmployee.toString() == "true"
              ? true
              : false;
          this.bookParam.paymentInfo.creditCardOwner =
            this.creditCardForm.cardNumberName;

          this.bookParam.paymentInfo.isVirtualCard =
            this.creditCardForm.isVirtualCard;

          this.bookParam.paymentInfo.creditCardCompanyCode =
            this.creditCardForm.cardType; //公司code
          this.bookParam.paymentInfo.formOfPayment = "creditcard"; //支付方式，默认信用卡
          let mouth = new Date(this.creditCardForm.validityDate).getMonth() + 1;
          this.bookParam.paymentInfo.validMonth =
            mouth > 9 ? mouth.toString() : "0" + mouth.toString(); //月
          this.bookParam.paymentInfo.validYear = new Date(
            this.creditCardForm.validityDate
          )
            .getFullYear()
            .toString(); //年
          this.bookParam.paymentInfo.creditCardNumber =
            this.creditCardForm.creditcard; //卡号
          if (this.bookParam.isNeedCvv) {
            this.bookParam.paymentInfo.CVV =
              this.creditCardForm.CVV; //CVV
          }
          createBooking(this.bookParam)
            .then((res) => {
              this.submitLoading = false;
              this.isChecked = true;
              if (res.code === 200) {
                if (res.data.error.code == 10809) {
                  this.toCon(res.data.bookingId);
                } else if (codeIsCode(res.data.error.code)) {
                  //预定失败 需要跳转
                  this.orderIdTo = res.data.bookingId;
                  if (res.data.error.isMapping == true) {
                    let message = "";
                    if (this.$i18n.locale == "en") {
                      message = res.data.error.enMessage;
                    }
                    else {
                      message = res.data.error.message;
                    }
                    this.confirmMsg = message;
                    this.confirmFlag = true;
                  }
                  else {
                    this.confirmMsg =
                      this.$t("ERRORMESSAGE.BOOKINGFAILED") +
                      (this.$t("ERRORMESSAGE." + res.data.error.code) ===
                        "ERRORMESSAGE." + res.data.error.code
                        ? this.$t("ERRORMESSAGE.NOTFOUND")
                        : this.$t("ERRORMESSAGE." + res.data.error.code));
                    this.confirmFlag = true;
                    console.log(
                      "创建订单失败, code:" + res.data.error.code,
                      res.data.error.message
                    );
                  }
                } else if (res.data.error.code != 0) {
                  //预定失败 需要跳转
                  this.orderIdTo = res.data.bookingId;
                  if (res.data.error.isMapping == true) {
                    let message = "";
                    if (this.$i18n.locale == "en") {
                      message = res.data.error.enMessage;
                    }
                    else {
                      message = res.data.error.message;
                    }
                    this.confirmMsg = message;
                    this.confirmFlag = true;
                  }
                  else {
                    this.confirmFlag = true;
                    this.confirmMsg =
                      this.$t("ERRORMESSAGE." + res.data.error.code) ===
                        "ERRORMESSAGE." + res.data.error.code
                        ? this.$t("ERRORMESSAGE.NOTFOUND")
                        : this.$t("ERRORMESSAGE." + res.data.error.code);
                    console.log(
                      "创建订单失败, code:" + res.data.error.code,
                      res.data.error.message
                    );
                  }
                } else {
                  this.toCon(res.data.bookingId);
                }
              } else if (res.code === 500) {
                this.confirmFlag = true;
                // this.confirmMsg = this.$t("ERRORMESSAGE.ORDER500");
                if (res.message == "ORDER501") {
                  this.confirmMsg = this.$t("ERRORMESSAGE.ORDER501");
                }
                else {
                  this.confirmMsg = this.$t("ERRORMESSAGE.ORDER500");
                }
                console.log("创建订单失败,code:" + res.code, res.message);
              }
              else {
                //预定失败 需要跳转
                this.orderIdTo = res.data.bookingId;
                if (res.data.error.isMapping == true) {
                  let message = "";
                  if (this.$i18n.locale == "en") {
                    message = res.data.error.enMessage;
                  }
                  else {
                    message = res.data.error.message;
                  }
                  this.confirmMsg = message;
                  this.confirmFlag = true;
                }
                else {
                  this.confirmFlag = true;
                  this.confirmMsg =
                    this.$t("ERRORMESSAGE." + res.code) ===
                      "ERRORMESSAGE." + res.code
                      ? this.$t("ERRORMESSAGE.NOTFOUND")
                      : this.$t("ERRORMESSAGE." + res.code);
                  console.log("创建订单失败,code:" + res.code, res.message);
                }
              }
            })
            .catch((err) => {
              this.submitLoading = false;
              this.isChecked = true;
              this.confirmFlag = true;
              this.confirmMsg = this.$t("ERRORMESSAGE." + err.mesCode);
              console.log("创建订单异常:", err.objError);
            });
        } else {
          this.submitLoading = false;
          this.isChecked = true;
          return false;
        }
      });
    },
    //获取userinfo
    getuserInfo() {
      let params = {
        params: {
          loginId: this.bookingAgents.userId,
        },
      };
      getuserinfo(params)
        .then((res) => {
          if (res.code === 200) {
            this.AgentsUserInfo = res.data;
          }
        })
        .catch((err) => {
          this.submitLoading = false;
          console.log(err);
        });
    },
    backBooking() {
      this.$router.push({
        path: "/booking",
        query: { sourceType: this.$objBaseInfo.sourceType },
      })
    },
  },
};
</script>

<style scoped lang="stylus">
/* 手机、平板屏幕 */
@media screen and (max-width: 960px) {
  .label_name_text {
    width: 10rem;
  }
  .mobile_span_room {
    max-width: 75%;
  }

  .hotel_container {
    overflow: hidden;
  }

  .s_btn_small_add {
    width: 17.6rem;
    background-color: #ffffff;
    color: #fc6640;
    border: 1px solid #fc6640;
  }
  .bg-purple-light {
    margin-bottom: 1rem;
    height: 8rem;
  }
  #nav2 {
    margin: 1.3rem 0;
  }

  #nav {
    margin-top: 1.3rem;
    background-color: #ffffff;
  }

  .big_font {
    width: 100%;
    white-space: normal;
    font-size: 1.8rem;
    font-family: PingFang SC, arial, helvetica, "helvetica neue", verdana, sans-serif;
    color: #333f48;
    line-height: 25px;
    margin-left: 1.3rem;
    margin-top: 1.3rem;
    display: inherit;
    padding-top: 13px;
    padding-right: 65rem;
  }
  #box1 {
    padding: 1.5rem 0;
  }
  #box2 {
    padding: 0 2rem;
  }
  .small_font {
    height: 2rem;
    font-size: 1.4rem;
    font-family: PingFang SC, arial, helvetica, "helvetica neue", verdana, sans-serif;
    color: #333f48;
    line-height: 2rem;
  }

  .grey_small_font {
    font-size: 1.4rem;
    font-family: PingFang SC, arial, helvetica, "helvetica neue", verdana, sans-serif;
    color: #6f787e;
  }
  ::v-deep .el-form-item__label {
    text-align: left;
    font-size: 1.6rem;
    padding: 0;
    height: 3rem;
  }
  ::v-deep .el-input {
    font-size: 1.4rem;
  }
  .el-select-dropdown__item {
    font-size: 1.4rem !important;
  }
  ::v-deep .el-form-item__error {
    padding-top: 2px;
  }
}

/* 电脑屏幕 */
@media screen and (min-width: 961px) {
  .label_name_text {
    width: 12.8rem;
  }
  .s_btn_small_add {
    width: 17.6rem;
    background-color: #ffffff;
    color: #fc6640;
    border: 1px solid #fc6640;
  }

  .save-check {
    padding-left: 5rem;
  }
  .bg-purple-light {
    margin-bottom: 3rem;
    margin-left: 4rem;
  }
  #box1 {
    padding: 2rem 0;
  }
  #box2 {
    padding: 0 2rem;
  }
  .content_size {
    margin-left: 6rem !important;
    margin-right: 6rem !important;
  }

  #nav2 {
    margin: 1.3rem 6rem;
    /* border: 10px solid #7F8C8D; */
  }

  #nav {
    margin: 1.3rem 6rem;
    background-color: #ffffff;
  }

  .big_font {
    height: 25px;
    white-space: nowrap;
    font-size: 1.8rem;
  }

  .small_font {
    height: 2rem;
    font-size: 14px;
    font-family: PingFang SC, arial, helvetica, "helvetica neue", verdana, sans-serif;
    color: #333f48;
    line-height: 2rem;
  }

  .grey_small_font {
    font-size: 14px;
    font-family: PingFang SC, arial, helvetica, "helvetica neue", verdana, sans-serif;
    color: #6f787e;
  }
  .big_font {
    /* width: 421px; */
    font-size: 18px;
    font-family: PingFang SC, arial, helvetica, "helvetica neue", verdana, sans-serif;
    /* font-weight: 600; */
    color: #333f48;
    line-height: 25px;
    margin-left: 1.3rem;
    margin-top: 1.3rem;
    display: inherit;
    padding-top: 13px;
    padding-right: 65rem;
  }
  ::v-deep .el-form-item__label {
    text-align: left;
  }
  .svg-icon {
    width: 4.4rem!important;
    height: 4.4rem!important;
  }
}

.holewidth {
  width: 100%;
}

.item {
  padding-bottom: 1.5rem;
  border-bottom: 0.2rem dotted rgb(151, 151, 151);
}

.bread_inner /deep/ .el-breadcrumb__inner {
  color: #fc6640;
}

.button_sty {
  width: 17.6rem;
  height: 5rem;
}

.myinput_inner /deep/ .el-input__inner {
  height: 100%;
  border-radius: 0;
}

.grey_input {
  /* width: 100%;
  height: 0px; */
  margin-top: -0.5rem;
  background: #e7e9ea;
  border-radius: 2px;
  /* border: 1px solid #e7e9ea; */
}

.inputMonth::-webkit-datetime-edit-text {
  color: blue;
  padding: 1.3rem;
}

.inputMonth::-webkit-datetime-edit-month-field {
  color: red;
}

.last_part {
  background-color: #f1e4c4;
}

#nav2 div {
  /* 占有比例 */
  -webkit-box-flex: 1;
  -moz-box-flex: 1;
}

#nav div {
  /* 占有比例 */
  -webkit-box-flex: 1;
  -moz-box-flex: 1;
}

#box3 {
  display: flex;
  justify-content: center;
  align-items: center;
}

#box4 {
  background: #ffffff;
}

#box5 {
  background: #ffffff;
}

#box6 {
  background: #ffffff;
}

.align_center {
  display: flex;
  align-items: center;
}

.warning_sty {
  height: 30px;
  background: #f1e4c4;
  border-top: 3px solid red;
}

.fontstyle {
  height: 2rem;
  font-size: 1.4rem;
  font-family: PingFang SC, arial, helvetica, "helvetica neue", verdana, sans-serif;
  /* font-weight: 600; */
  color: #333f48;
}

.myColor /deep/ .el-breadcrumb__inner {
  font-size: 1.4rem;
  font-family: PingFang SC, arial, helvetica, "helvetica neue", verdana, sans-serif;
  /* font-weight: 600; */
  color: #333f48;
}

.row-bg {
  padding: 10px 0;
  background-color: #f9fafc;
}

.grid-content {
  min-height: 3rem;
}

.row-bg {
  padding: 1rem 0;
  background-color: #f9fafc;
}

.slash {
  background: linear-gradient(
    to top right,
    transparent 0%,
    transparent calc(50% - 1px),
    #c0c4cc 50%,
    transparent calc(50% + 1px),
    transparent 100%
  );
}

.card-input-icon {
  ::v-deep .el-input__prefix {
    right: 1rem;
    left: unset;
  }

  ::v-deep .el-input__inner {
    padding-left: 1rem;
  }
}
::v-deep input.el-input__inner {
  height: 3rem !important;
  line-height: normal;
  transform: translateZ(0);
  outline: none;
}
.custom-icon {
  width: 1.5rem;
  height: 1.5rem;
  vertical-align: middle;
  fill: currentColor;
  cursor: pointer;
}
</style>
<style lang="stylus">
.grey_small_font {
  span.small_font {
    color: #333f48;
  }
}
.svg-icon {
  width: 4.4rem;
  height: 4.4rem;
}
</style>
